<template>
  <div class="site-width">
    <div class="row feature-blocks p-0 mt-0">
      <div
        class="columns feature-block feature-block--gray f22-header px-md-0 bg-mycellar text-left w-full"
      >
        <div class="columns-12-10-8-6 bg-mycellar__placement">
          <h2>Shop Your Past Purchases</h2>
          <nuxt-link to="/cellar/wines/" class="link-overlay">
            <span class="sr-only">Go to My Cellar</span>
          </nuxt-link>
          <p class="large">
            Plus, explore the wines most similar to those bottles.
          </p>
          <p class="feature-block__cta">
            <span class="underline nowrap longarrow-black"
              >Go to My Cellar</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserOrderSection',
}
</script>
